// extracted by mini-css-extract-plugin
module.exports = {"filterTag":"FiltersDisplay_filterTag__MrZP7","wrapper":"FiltersDisplay_wrapper__2jV6s"};